import React from 'react';
import loaderIcon from '../../assets/images/login-and-signup/loader.gif';
import HeaderUi from '../header/Header';
import { Link } from 'react-router-dom';

function Onboarding() {
    return (
        <>
            <HeaderUi />

            <div className="container_box--main">
                <div className="container_box_start">
                </div>

                <div className="container_box_end d_flex flex_column justify_content_center">
                    <div className="container_box--intro onb">
                        <h1 className='heading'>Welcome to USP!</h1>
                        <p className='text'>To kick things off, we'd love to learn more about your company to better serve your needs.</p>
                    </div>
                    <div className="dummy_img"></div>
                    <Link className='btn_primary btn w_lg' to="/onboarding-form-ui">
                        <span>let's get started</span>
                        <img src={loaderIcon} alt='USP' className='loader_icon' />
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Onboarding
